import React, { Component } from 'react';
import { Panel, Table } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

import CheckoutStepCalculator from '../../services/checkout-step-calculator';

class OrderState extends Component {
    getOrderStateConfig = (orderState) => {
        const config = {
            complete: {
                color: 'rgb(255, 109,2)',
                text: this.props.intl.formatMessage({ id: 'order-complete', defaultMessage: 'Complete' }),
            },
            cart: {
                color: 'rgb(255, 109,2)',
                text: this.props.intl.formatMessage({ id: 'order-cart', defaultMessage: 'Cart' }),
            },
            address: {
                color: 'rgb(255, 109,2)',
                text: this.props.intl.formatMessage({ id: 'order-address', defaultMessage: 'Address' }),
            },
            payment: {
                color: '#000',
                text: this.props.intl.formatMessage({ id: 'order-payment', defaultMessage: 'Payment' }),
            },
            resume: {
                color: '#000',
                text: this.props.intl.formatMessage({ id: 'order-resume', defaultMessage: 'Resume' }),
            },
            canceled: {
                color: '#000',
                text: this.props.intl.formatMessage({ id: 'order-canceled', defaultMessage: 'Canceled' }),
            },
            awaiting_return: {
                color: '#000',
                text: this.props.intl.formatMessage({ id: 'order-awaiting-return', defaultMessage: 'Awaiting Return' }),
            },
            returned: {
                color: '#000',
                text: this.props.intl.formatMessage({ id: 'order-returned', defaultMessage: 'Returned' }),
            },
        };

        return config[orderState];
    }

    render() {
        const { state } = this.props;
        const orderStateConfig = this.getOrderStateConfig(state);
        if (orderStateConfig) {
            return (<span style={{ color: orderStateConfig.color }}>{orderStateConfig.text}</span>);
        }
        return null;
    }
}

export default injectIntl(OrderState);



/** WEBPACK FOOTER **
 ** ./src/components/order/order-state.jsx
 **/